export default __webpack_public_path__ + "static/wamo-nextImage-45f4308b190cc5de0dcfa7cdfad5ac16.jpg";